import type { ExportUpdatedPayload } from '@gozoki/api-types'
import { useContext, useEffect } from 'react'
import { AuthContext } from '~/utils/context/auth.context'
import { getSocket } from './socketManager'

/**
 * `export:updated` du namespace racine (room `admin:<id>` de chaque demandeur, lot S8.2) : un
 * changement de statut d'export, sans URL. Le sondage reste le filet si le socket tombe.
 */
export const useExportUpdates = (onUpdate: (payload: ExportUpdatedPayload) => void) => {
  const { authenticated } = useContext(AuthContext)

  useEffect(() => {
    if (!authenticated) return

    const socket = getSocket()
    socket.on('export:updated', onUpdate)

    return () => {
      socket.off('export:updated', onUpdate)
    }
  }, [authenticated, onUpdate])
}
